<script setup lang="ts">
defineProps<{
  readonly text: string
  readonly name: string
  readonly role: string
  readonly initials: string
}>()
</script>

<template>
  <blockquote class="fw-welcome-quote">
    <p>&ldquo;{{ text }}&rdquo;</p>
    <footer>
      <span class="fw-welcome-quote__initials">{{ initials }}</span>
      <span class="fw-welcome-quote__byline">
        <strong>{{ name }}</strong>
        <span>{{ role }}</span>
      </span>
    </footer>
  </blockquote>
</template>

<style scoped>
.fw-welcome-quote {
  border-left: 2px solid rgba(255, 255, 255, 0.35);
  padding-left: 16px;
  max-width: 52ch;
  margin: 0;
  font-size: clamp(13px, 1.25vw, 14.5px);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.9);
}

.fw-welcome-quote footer {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.fw-welcome-quote__initials {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10.5px;
  font-weight: 600;
  flex: none;
}

.fw-welcome-quote__byline {
  display: flex;
  flex-direction: column;
  font-size: 12.5px;
}
</style>
